export const STORAGE_AUTOMATER_KEY = "importsFilterAutomater";
export const STORAGE_SEARCH_KEY = "importsFilterSearch";
